import { useQuery } from '@tanstack/react-query';

import { useAuth } from '@/contexts/AuthContext';
import TaxonomiesService from '@/services/TaxonomiesService';

export const GET_TAXONOMY_CURRENT_PROPERTIES_BY_CATEGORY_NAME = (
  taxonomyVersion: string,
  categoryName: string,
) => [
  'getTaxonomyCurrentPropertiesByCategoryName',
  taxonomyVersion,
  categoryName,
];

export function useGetTaxonomyCurrentPropertiesByCategoryName(
  categoryName: string,
) {
  const { user } = useAuth();

  const { data, isFetching } = useQuery({
    queryKey: GET_TAXONOMY_CURRENT_PROPERTIES_BY_CATEGORY_NAME(
      user?.customer.taxonomyVersion ?? '0',
      categoryName,
    ),
    queryFn: () =>
      TaxonomiesService.getTaxonomyCurrentPropertiesByCategoryName(
        categoryName,
      ),
  });

  return {
    taxonomies: data,
    isLoading: isFetching,
  };
}
